<app-page heading="Home">
  <div class="app-row gapped loose hh-fill">
    <div class="app-fill app-column-fill gapped">
      <div class="app-row app-fill-first gapped">
        <h2>Packs</h2>
        <app-button type="show_all" transparent [routerLink]="['/packs']"/>
      </div>
      <div class="scroll-container">
        <app-entity-list [items]="packs" [linked]="true">No packs found</app-entity-list>
      </div>
    </div>
    <div class="app-fill app-column-fill gapped">
      <div class="app-row app-fill-first gapped">
        <h2>Prompts</h2>
        <app-button type="show_all" transparent [routerLink]="['/prompts']"/>
      </div>
      <div class="scroll-container">
        <app-entity-list [items]="prompts" [linked]="true">No prompts found</app-entity-list>
      </div>
    </div>
  </div>
</app-page>
